var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_vm._v(" "+_vm._s(_vm.group.name)+" ")]),_c('v-expansion-panel-content',[_c('v-expansion-panels',_vm._l((_vm.group.stages),function(stage){return _c('accordion-services-group',{key:stage.id,attrs:{"group":stage},on:{"select-service":_vm.onSelectService}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }